// 節點樣式配置
export const NODE_STYLES = {
  default: {
    padding: 8,
    background: '#fff',
    border: '1.5px solid #1890ff',
    borderRadius: 6,
    minWidth: 140,
    minHeight: 50,
    boxSizing: 'border-box',
    position: 'relative',
    boxShadow: '0 1px 4px #0001',
    transition: 'box-shadow 0.2s',
  },
  input: {
    padding: 8,
    background: '#f6ffed',
    border: '2px solid #52c41a',
    borderRadius: 6,
    minWidth: 100,
    minHeight: 50,
    boxSizing: 'border-box',
    position: 'relative',
    boxShadow: '0 1px 4px #0001',
    transition: 'box-shadow 0.2s',
  },
  output: {
    padding: 8,
    background: '#fffbe6',
    border: '2px solid #faad14',
    borderRadius: 6,
    minWidth: 100,
    minHeight: 50,
    boxSizing: 'border-box',
    position: 'relative',
    boxShadow: '0 1px 4px #0001',
    transition: 'box-shadow 0.2s',
  },
  selected: {
    background: '#e6f7ff',
    boxShadow: '0 0 8px #1890ff55',
  },
  inputSelected: {
    background: '#f6ffed',
    boxShadow: '0 0 8px #52c41a88',
  },
  outputSelected: {
    background: '#fffbe6',
    boxShadow: '0 0 8px #faad1488',
  },
  unselected: {
    background: '#fff',
  },
};

// 連接點樣式
export const HANDLE_STYLES = {
  source: {
    background: '#52c41a',
    border: '2px solid #389e0d',
    width: 12,
    height: 12,
    borderRadius: '50%',
    boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
    zIndex: 10,
  },
  target: {
    background: '#faad14',
    border: '2px solid #d48806',
    width: 12,
    height: 12,
    borderRadius: '50%',
    boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
    zIndex: 10,
  },
  // 通用樣式，用於可切換的 handle
  default: {
    width: 12,
    height: 12,
    borderRadius: '50%',
    boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
    zIndex: 1000,
    border: '2px solid',
    pointerEvents: 'auto',
  },
};

// 刪除按鈕樣式
export const DELETE_BUTTON_STYLES = {
  position: 'absolute',
  top: -8,
  right: -8,
  background: '#ff4d4f',
  border: 'none',
  borderRadius: '50%',
  width: 24,
  height: 24,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
  zIndex: 1000,
  fontSize: '12px',
  color: '#fff',
  fontWeight: 'bold',
  padding: '0',
  minWidth: '50px',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
};

// 模擬數據
export const MOCK_DATA = {
  templates: [
    { id: 1, name: '歡迎訊息', content: '歡迎使用我們的服務！' },
    { id: 2, name: '確認通知', content: '您的訂單已確認' },
    { id: 3, name: '提醒訊息', content: '請記得完成您的任務' },
  ],
  users: [
    { id: 1, name: '張三', phone: '+85212345678', email: 'zhang@example.com' },
    { id: 2, name: '李四', phone: '+85287654321', email: 'li@example.com' },
    { id: 3, name: '王五', phone: '+85211223344', email: 'wang@example.com' },
  ],
  eforms: [
    { id: 1, name: '客戶資料表', description: '收集客戶基本資料', fields: ['姓名', '電話', '地址'] },
    { id: 2, name: '意見回饋表', description: '收集用戶意見', fields: ['評分', '建議', '聯絡方式'] },
    { id: 3, name: '申請表', description: '處理各種申請', fields: ['申請類型', '申請人', '申請內容'] },
  ],
};

// 節點類型配置
export const NODE_TYPE_CONFIGS = [
  {
    type: 'start',
    labelKey: 'workflowDesigner.startNode',
    fallbackLabel: 'Start',
    icon: 'PlayCircleOutlined',
    iconColor: '#52c41a',
    category: 'Control',
    description: '工作流程開始節點',
    isImplemented: true,
    hasExecution: false,
  },
  {
    type: 'sendWhatsApp',
    labelKey: 'workflowDesigner.sendMessageNode',
    fallbackLabel: 'Send Message',
    icon: 'SendOutlined',
    iconColor: '#1890ff',
    category: 'Communication',
    description: '發送 WhatsApp 訊息',
    isImplemented: true,
    hasExecution: true,
  },
  {
    type: 'sendWhatsAppTemplate',
    labelKey: 'workflowDesigner.sendTemplateNode',
    fallbackLabel: 'Send WhatsApp Template',
    icon: 'MessageOutlined',
    iconColor: '#1890ff',
    category: 'Communication',
    description: '發送 WhatsApp 模板訊息',
    isImplemented: true,
    hasExecution: true,
  },
  {
    type: 'sendWhatsAppShoppingCart',
    labelKey: 'workflowDesigner.shoppingCartNode',
    fallbackLabel: 'WhatsApp Shopping Cart',
    icon: 'ShoppingCartOutlined',
    iconColor: '#eb2f96',
    category: 'Communication',
    description: '發送 WhatsApp 多商品購物車訊息',
    isImplemented: true,
    hasExecution: true,
    hidden: true,
  },
  {
    type: 'sendInstitutionOrderingCart',
    labelKey: 'workflowDesigner.institutionOrderingCartNode',
    fallbackLabel: 'Institution Ordering Cart',
    icon: 'ShoppingCartOutlined',
    iconColor: '#eb2f96',
    category: 'Communication',
    description: '發送 Flows 自訂購物車（選 collection → 商品列表 → 明細 → 購物車 → 提交）',
    isImplemented: true,
    hasExecution: true,
  },
  {
    type: 'chatOrderingCart',
    labelKey: 'workflowDesigner.chatOrderingCartNode',
    fallbackLabel: 'Chat Shopping Cart',
    icon: 'ShoppingCartOutlined',
    iconColor: '#f759ab',
    category: 'Communication',
    description: '聊天購物車：以 AI 員工與用戶對答下單，自動解析文字／圖片、匹配商品、覆單確認後寫入 Sales Order',
    isImplemented: true,
    hasExecution: true,
  },
  {
    type: 'chatBot',
    labelKey: 'workflowDesigner.chatBotNode',
    fallbackLabel: 'Chat Bot',
    icon: 'RobotOutlined',
    iconColor: '#13c2c2',
    category: 'Communication',
    description: 'AI 聊天機械人：以知識庫與用戶對答，不連接商品或下單流程',
    isImplemented: true,
    hasExecution: true,
  },
  {
    type: 'waitReply',
    labelKey: 'workflowDesigner.waitReplyNode',
    fallbackLabel: 'Wait for User Reply',
    icon: 'ClockCircleOutlined',
    iconColor: '#fa8c16',
    category: 'Control',
    description: '等待用戶回覆',
    isImplemented: true,
    hasExecution: true,
  },
  {
    type: 'waitForQRCode',
    labelKey: 'workflowDesigner.waitForQRCodeNode',
    fallbackLabel: 'Wait for QR Code',
    icon: 'ClockCircleOutlined',
    iconColor: '#fa8c16',
    category: 'Control',
    description: '等待 QR Code 掃描',
    isImplemented: true,
    hasExecution: true,
  },
  {
    type: 'waitForLocation',
    labelKey: 'workflowDesigner.waitForLocationNode',
    fallbackLabel: 'Template + Location Request',
    icon: 'EnvironmentOutlined',
    iconColor: '#13c2c2',
    category: 'Control',
    description: '先發模板再請求分享位置',
    isImplemented: true,
    hasExecution: true,
  },
  {
    type: 'waitForEmailReply',
    labelKey: 'workflowDesigner.waitForEmailReplyNode',
    fallbackLabel: 'Wait for Email Reply',
    icon: 'ClockCircleOutlined',
    iconColor: '#fa8c16',
    category: 'Control',
    description: '等待 Email 回覆',
    isImplemented: true,
    hasExecution: true,
  },
  {
    type: 'switch',
    labelKey: 'workflowDesigner.switchNode',
    fallbackLabel: 'Switch',
    icon: 'CheckCircleOutlined',
    iconColor: '#722ed1',
    category: 'Control',
    description: '條件分支節點',
    isImplemented: true,
    hasExecution: true,
  },
  {
    type: 'dataSetQuery',
    labelKey: 'workflowDesigner.dataSetQueryNode',
    fallbackLabel: 'DataSet Query/Update',
    icon: 'DatabaseOutlined',
    iconColor: '#faad14',
    category: 'Data',
    description: 'DataSet 查詢、插入、更新或刪除',
    isImplemented: true,
    hasExecution: true,
  },
  {
    type: 'processDataCell',
    labelKey: 'workflowDesigner.processDataCellNode',
    fallbackLabel: 'Process Data Cell Operation',
    icon: 'TableOutlined',
    iconColor: '#0958d9',
    category: 'Data',
    description: '設定流程資料格數值（複製、固定值、JSON、AI）',
    isImplemented: true,
    hasExecution: true,
  },
  {
    type: 'callApi',
    labelKey: 'workflowDesigner.callApiNode',
    fallbackLabel: 'Trigger External API',
    icon: 'ApiOutlined',
    iconColor: '#13c2c2',
    category: 'Integration',
    description: '調用外部 API',
    isImplemented: true,
    hasExecution: true,
  },
  {
    type: 'sendEForm',
    labelKey: 'workflowDesigner.sendEFormNode',
    fallbackLabel: 'Send eForm',
    icon: 'FormOutlined',
    iconColor: '#2f54eb',
    category: 'Form',
    description: '發送電子表單',
    isImplemented: true,
    hasExecution: true,
  },
  {
    type: 'generateHtmlReport',
    labelKey: 'workflowDesigner.generateHtmlReportNode',
    fallbackLabel: 'HTML Report',
    icon: 'FileTextOutlined',
    iconColor: '#9254de',
    category: 'Form',
    description: 'AI 產出可列印 HTML 報表',
    isImplemented: true,
    hasExecution: true,
  },
  {
    type: 'generateDocument',
    labelKey: 'workflowDesigner.generateDocumentNode',
    fallbackLabel: 'Generate Document',
    icon: 'FileAddOutlined',
    iconColor: '#9254de',
    category: 'Form',
    description: 'AI 產出結構化 JSON 並轉成 Office 文件',
    isImplemented: true,
    hasExecution: true,
  },
  {
    type: 'calendar',
    labelKey: 'workflowDesigner.calendarNode',
    fallbackLabel: 'Calendar',
    icon: 'CalendarOutlined',
    iconColor: '#13c2c2',
    category: 'Integration',
    description: 'AI 生成日曆指令，建立／修改／刪除日曆事件',
    isImplemented: true,
    hasExecution: true,
  },
  {
    type: 'odoo',
    labelKey: 'workflowDesigner.odooNode',
    fallbackLabel: 'Odoo',
    icon: 'OdooLogo',
    iconColor: '#714B67',
    category: 'Integration',
    description: 'Odoo 19 ERP 整合：PO / Quotation / SO / 發票 / 出貨 / 收貨 / 退貨 / 信用備忘錄 / 收款 / 查詢',
    isImplemented: true,
    hasExecution: true,
  },
  {
    type: 'end',
    labelKey: 'workflowDesigner.endNode',
    fallbackLabel: 'End',
    icon: 'StopOutlined',
    iconColor: '#ff4d4f',
    category: 'Control',
    description: '工作流程結束節點',
    isImplemented: true,
    hasExecution: false,
  },
];

